var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-container"},[_c('img',{staticClass:"banner-img",attrs:{"src":require("@/assets/member/member-img.png"),"alt":""}}),_c('div',{staticClass:"banner-block"},_vm._l((55),function(item,index){return _c('div',{key:index,staticClass:"block-item"})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }